@let footerBlock = block();

@if (footerBlock.styles) {
    <div [appCmsStyles]="footerBlock.styles"></div>
}
@if (footerBlock.content) {
    <div class="footer-column__content cms-content" [innerHtml]="footerBlock.content | trustHtml"></div>
}
@for (link of footerBlock.linksList; track link.id) {
    <cms-btn class="footer-column__link" [config]="link" />
}
